/* iZENAY — Section JS */

/* ── header.liquid — scroll state ── */
(function() {
  var header = document.getElementById('site-header');
  if (!header) return;

  var isHomepage = document.body.classList.contains('template-index');
  if (!isHomepage) return;

  function onScroll() {
    if (window.scrollY > 10) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* ── header.liquid — locale selector dropdown ── */
(function() {
  var btn      = document.getElementById('LocaleSelectorBtn');
  var dropdown = document.getElementById('LocaleSelectorDropdown');
  if (!btn || !dropdown) return;

  function openDropdown() {
    dropdown.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
  }

  function closeDropdown() {
    dropdown.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
  }

  btn.addEventListener('click', function(e) {
    e.stopPropagation();
    if (dropdown.hidden) openDropdown();
    else closeDropdown();
  });

  document.addEventListener('click', function(e) {
    if (!btn.contains(e.target) && !dropdown.contains(e.target)) {
      closeDropdown();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeDropdown();
  });
})();

/* ── header.liquid — mobile nav ── */
(function() {
  var hamburger = document.getElementById('hamburger-btn');
  var mobileNav = document.getElementById('mobile-nav');
  var overlay   = document.getElementById('mobile-nav-overlay');
  var closeBtn  = document.getElementById('mobile-nav-close');

  if (!hamburger || !mobileNav) return;

  function openMenu() {
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    hamburger.setAttribute('aria-expanded', 'true');
    hamburger.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    hamburger.setAttribute('aria-expanded', 'false');
    hamburger.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  hamburger.addEventListener('click', openMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeMenu();
  });
})();
